export default "__VITE_ASSET__CzNk7A4s__"